import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
export function SET_T_CODES(state, payload) {
  state.tCodeOptions = payload.data.map(function (_ref) {
    var code = _ref.code,
      name = _ref.name;
    return {
      value: code,
      label: name
    };
  });
}